var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Card',{staticClass:"Chart",attrs:{"title":_vm.title}},[_vm._t("head"),_c('Frappe',_vm._b({ref:"frappe",attrs:{"id":_vm.id,"axisOptions":{
      xAxisMode: 'tick',
      xIsSeries: true,
    },"colors":['#4b6ce6', '#4b6ce6', '#4b6ce6'],"dataSets":_vm.dataSets,"discreteDomains":false,"height":_vm.height,"labels":_vm.labels,"lineOptions":{
      heatline: 1,
      regionFill: 1,
    },"type":"axis-mixed"}},'Frappe',_vm.$attrs,false))],2)}
var staticRenderFns = []

export { render, staticRenderFns }